import { handleAuthorization, handleOkResponseJson } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterUnidadesMedidaAsync,
    enviarUnidadeMedidaAsync,
    editarUnidadeMedidaAsync,
	downloadLista
}

export const obterUnidadesMedidaAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeMedida/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarUnidadeMedidaAsync = async (abreviatura, descricao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ abreviatura, descricao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeMedida`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarUnidadeMedidaAsync = async (id, abreviatura, descricao, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, abreviatura, descricao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/UnidadeMedida/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/UnidadeMedida/downloadUnidadesMedida`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'unidadesMedida' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}
